import { isRawScreenEvent } from '@emma-helpers/default-events.helper';
import { AppEventPartial, DEFAULT_SKAN_VALUE, EMMA_EVENTS } from 'emma-common-ts/emma';

export const getDefaultAppEvent = (): AppEventPartial => {
  return {
    id: undefined,
    name: '',
    active: true,
    category: null,
    order: 0,
    token: '',
    postback: '',
    useAdwords: false,
    useFacebook: false,
    __isSkanValueEnable: false,
    skanValue: DEFAULT_SKAN_VALUE,
  };
};

export const getEventId = (event: AppEventPartial): number | string | null => {
  if (isRawScreenEvent(event)) {
    return event.screenId || null;
  } else {
    return event.id || null;
  }
};

export const eventsTokenDefault = [
  EMMA_EVENTS.RETARGETING_OPEN,
  EMMA_EVENTS.AUTO_EVENT,
  EMMA_EVENTS.FIRST_LOGIN,
  EMMA_EVENTS.INSTALL,
];
